import { useCallback } from "react";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import GlobalMessages from "messages/messages";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(theme => ({
  wrapper: {
    border: `1px solid rgba(0,0,0,0.5)`,
    borderRadius: `15px`,
    padding: theme.spacing(2),
    width: "100%",
    maxWidth: "500px",
    minWidth: "400px",
  },
  item: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  label: {
    color: "gray",
    textTransform: "capitalize",
  },
}));

function PatientPreview({ patient }) {
  const classes = useStyles();

  const renderValue = useCallback(
    property => {
      if (!patient) {
        return "-";
      }

      const levels = property.split(".");

      let currentValue = patient;

      for (let i = 0; i < levels.length; i++) {
        if (currentValue && currentValue.hasOwnProperty(levels[i])) {
          currentValue = currentValue[levels[i]];
          continue;
        }

        return "-";
      }

      return currentValue || "-";
    },
    [patient],
  );

  return (
    <div className={classes.wrapper}>
      <div className={classes.item}>
        <Typography className={classes.label}>
          <FormattedMessage {...GlobalMessages.name} />
        </Typography>
        <Typography>{renderValue("name")}</Typography>
      </div>
      <div className={classes.item}>
        <Typography className={classes.label}>
          <FormattedMessage {...GlobalMessages.internal_ref} />
        </Typography>
        <Typography>{renderValue("internalRef")}</Typography>
      </div>
      <div className={classes.item}>
        <Typography className={classes.label}>
          <FormattedMessage {...GlobalMessages.caseNr} />
        </Typography>
        <Typography>{renderValue("caseId")}</Typography>
      </div>
      <div className={classes.item}>
        <Typography className={classes.label}>
          <FormattedMessage {...GlobalMessages.insurer} />
        </Typography>
        <Typography>{renderValue("care")}</Typography>
      </div>
      <div className={classes.item}>
        <Typography className={classes.label}>
          <FormattedMessage {...GlobalMessages.insuranceNumber} />
        </Typography>
        <Typography>{renderValue("insuranceNumber")}</Typography>
      </div>
      <div className={classes.item}>
        <Typography className={classes.label}>
          <FormattedMessage {...GlobalMessages.dentist} />
        </Typography>
        <Typography>{renderValue("dentist.name")}</Typography>
      </div>
    </div>
  );
}

PatientPreview.propTypes = {
  patient: PropTypes.object,
};

export default PatientPreview;
